import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import DeleteAccountPanel from '../components/DeleteAccountPanel';

export default function DeleteAccount() {
  const { user, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const deleted = Boolean((location.state as { deleted?: boolean } | null)?.deleted);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const signIn = async (event: React.FormEvent) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await login(email, password);
      navigate('/delete-account', { replace: true });
    } catch (err: any) {
      setError(err?.response?.data?.error || err?.message || 'Could not sign in.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-amber-50 px-4 py-10">
      <div className="mx-auto max-w-lg rounded-xl bg-white p-6 shadow-md border border-amber-100">
        <h1 className="text-2xl font-bold text-amber-900 mb-2">Delete your QahwaHub account</h1>
        <p className="text-sm text-gray-600 mb-4">
          You can also do this in the app under Profile or Settings. This page is the public web
          address for account deletion.
        </p>
        {deleted ? (
          <p className="text-green-800 bg-green-50 rounded p-3">
            Your account has been deleted. You are signed out. Order totals remain without your
            personal details.
          </p>
        ) : user ? (
          <DeleteAccountPanel />
        ) : (
          <form onSubmit={signIn} className="space-y-3">
            <p className="text-sm text-gray-700">Sign in, then confirm deletion with your password.</p>
            {error && <p className="text-sm text-red-700">{error}</p>}
            <div>
              <label className="block text-sm mb-1" htmlFor="delete-login-email">
                Email
              </label>
              <input
                id="delete-login-email"
                type="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>
            <div>
              <label className="block text-sm mb-1" htmlFor="delete-login-password">
                Password
              </label>
              <input
                id="delete-login-password"
                type="password"
                required
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                className="w-full px-3 py-2 border rounded-lg"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              className="w-full bg-amber-700 text-white py-2 rounded-lg font-semibold disabled:opacity-50"
            >
              {busy ? 'Signing in…' : 'Sign in to continue'}
            </button>
          </form>
        )}
        <p className="mt-6 text-sm text-gray-600">
          <Link to="/login" className="text-amber-800 font-semibold">
            Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
